import { IAnswer } from '../../../modules/api/models/reflist/reflist.types';
import { stripAccentuatedChars } from '../helpers';

export const getDefaultAnswers = (
  answers: IAnswer[],
  defaultAnswersIds: number[] // Answers id order is important so we loop on it
) =>
  defaultAnswersIds.reduce<IAnswer[]>((results, id) => {
    const defaultAnswer = answers.find(answer => answer.id === id);

    if (defaultAnswer) results.push(defaultAnswer);

    return results;
  }, []);

export function getFilteredAnswers(answers: IAnswer[], search: string) {
  const unAccentuatedSearch = stripAccentuatedChars(search);

  return answers
    .filter(answer =>
      stripAccentuatedChars(unescape(answer.label)).includes(
        unAccentuatedSearch
      )
    )
    .sort((a, b) => {
      if (a.label < b.label) return -1;

      if (a.label > b.label) return 1;

      return 0;
    });
}

export function getAnswersByTextSearch(
  answers: IAnswer[],
  search: string,
  defaultAnswerIds?: number[],
  questionId?: number
) {
  const defaultAnswers = getDefaultAnswers(answers, defaultAnswerIds || []);

  if (search.length < 3) {
    return defaultAnswers;
  }

  const filteredAnswers = getFilteredAnswers(answers, search);

  if (filteredAnswers.length > 0) {
    return filteredAnswers;
  }

  if (questionId) {
    return answers.filter(({ id }) => id === questionId);
  }

  return [];
}

export function getAnswersWithoutDefaultAnswersByTextSearch(
  answers: IAnswer[],
  search: string,
  questionId?: number
) {
  if (search.length < 3) {
    return;
  }

  const filteredAnswers = getFilteredAnswers(answers, search);

  if (filteredAnswers.length > 0) {
    return filteredAnswers;
  }

  if (questionId) {
    return answers.filter(({ id }) => id === questionId);
  }

  return [];
}
